import { FC, Fragment, useEffect, useState } from "react";
import { Container, TruncatedTd } from "./style";
import Pagination from "components/particles/pagination/pagination";
import NoDataFound from "components/particles/no-data-found";
import view from "assets/images/view-icon.svg";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { siteRoutes } from "utils/helpers/enums/routes.enums";
import Button from "components/particles/primary-button";
import { useHomeChef } from "./useHook";
import { useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { HomeChefListSearchDTO } from "utils/helpers/models/homeChef.dto";
import PlaceholderImage from "assets/images/place-img.png";
import { GENDER_OPTIONS } from "utils/helpers/constants/gender";

const HomeChef: FC = () => {
  const { getHomeChef, updateUserStatusById } = useHomeChef();
  const navigate = useNavigate();
  const [data, setData] = useState<any[]>([]);
  const [searchFilters, setSearchFilters] = useState<HomeChefListSearchDTO>({
    status: '',
    name: "",
    mobileNumber: "",
    gender: null,
  });

  const [homeCookPaginationState, setHomeCookPaginationState] = useState<any>({});
  const [searchParams, setSearchParams] = useSearchParams();
  const location = useLocation();

  const {
    register,
    handleSubmit,
    setValue,
    reset: formReset,
  } = useForm<HomeChefListSearchDTO>();
  const isLoading = useSelector((state: any) => state.user.isLoading);
  // const search = (filters: HomeChefListSearchDTO) => {
  //   setSearchFilters(filters);
  //   const apiFilters = {
  //     ...filters,
  //     status: filters.status ?? '',
  //     gender: filters.gender ?? '',
  //   };

  //   getHomeChef(setData, { ...apiFilters, limit, offset: 0 }, setHomeCookPaginationState);
  // };
  const search = (filters: HomeChefListSearchDTO) => {
    const apiFilters = {
      ...filters,
      status: filters.status ?? '',
      gender: filters.gender ?? '',
    };

    setSearchFilters(apiFilters);

    // Update searchParams in URL
    const newSearchParams = new URLSearchParams();
    if (filters.name) newSearchParams.set("name", filters.name);
    if (filters.mobileNumber) newSearchParams.set("mobileNumber", filters.mobileNumber);
    if (filters.gender) newSearchParams.set("gender", filters.gender);
    if (filters.status) newSearchParams.set("status", filters.status);

    setSearchParams(newSearchParams);

    getHomeChef(setData, { ...apiFilters, offset: 0, limit }, setHomeCookPaginationState);
  };



  // const reset = () => {
  //   setSearchFilters({
  //     status: '',
  //     name: "",
  //     mobileNumber: "",
  //     gender: null,
  //   }); // ✅ clear filters
  //   setValue("name", "");
  //   setValue("mobileNumber", "");
  //   setValue("gender", "");
  //   setValue("status", "");
  //   formReset();
  //   getHomeChef(setData, { offset: 0, limit }, setHomeCookPaginationState);
  // };

  const reset = () => {
    const defaultFilters = {
      name: "",
      mobileNumber: "",
      gender: null,
      status: '',
    };

    setSearchFilters(defaultFilters);
    setSearchParams({}); // ← clear URL
    formReset();

    getHomeChef(setData, { offset: 0, limit }, setHomeCookPaginationState);
  };


  const limit = 10;

  const fetchNextRecords = (offset: number) => {

    const apiFilters = {
      ...searchFilters,
      status: searchFilters.status ?? '',
      gender: searchFilters.gender ?? '',
    };

    getHomeChef(setData, { ...apiFilters, offset, limit }, setHomeCookPaginationState);
    // getHomeChef(setData, offset, limit, setHomeCookPaginationState);
    const toTopElement = document.getElementById("toTop");
    if (toTopElement) {
      toTopElement.scrollIntoView({ behavior: "smooth" });
    } else {
      window.scrollTo(0, 0);
    }
  };

  useEffect(() => {
    // getHomeChef(setData, { offset: 0, limit: 10 }, setHomeCookPaginationState);
  }, [searchParams]);

  // const handleViewPage = (id: string, chef: any) => {
  //   navigate(siteRoutes.homeChefView, { state: { id, chef } });
  // };
  const handleViewPage = (id: string, chef: any) => {
    navigate(siteRoutes.homeChefView + `?${searchParams.toString()}`, {
      state: { id, chef },
    });
  };

  function capitalizeWords(str: string) {
    return str
      .toLowerCase()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  }

  const toggleUserStatus = async (userId: string, status: boolean) => {
    const updatedData = data.map((chef) =>
      chef.id === userId ? { ...chef, status: !status } : chef
    );
    setData(updatedData);
    await updateUserStatusById(userId, updatedData, !status);
  };
  const columns: any = [
    {
      name: "Name",
      class: "",
    },
    {
      name: "Email",
      class: "",
    },
    {
      name: "Phone Number",
      class: "",
    },
    {
      name: "Gender",
      class: "th",
    },
    {
      name: "Location",
      class: "th",
    },
    {
      name: "Status",
      class: "th",
    },
    {
      name: "Actions",
      class: "th",
    },
  ];

  const statusOptions = [
    { label: "Active", value: "true" },
    { label: "Inactive", value: "false" },
  ];

  /////////////////////////////////////////////////////
  useEffect(() => {
  const name = searchParams.get("name") || "";
  const mobileNumber = searchParams.get("mobileNumber") || "";
  const gender = searchParams.get("gender") || "";
  const status = searchParams.get("status") || "";

 const filtersFromParams = {
  name,
  mobileNumber,
  gender: gender || "",   
  status,
};


  setValue("name", name);
  setValue("mobileNumber", mobileNumber);
  setValue("gender", gender);
  setValue("status", status);

  setSearchFilters(filtersFromParams);

  getHomeChef(
    setData,
    {
      ...filtersFromParams,
      offset: 0,
      limit,
    },
    setHomeCookPaginationState
  );
}, [searchParams]);


  return (
    <Container id="toTop">
      <h1>Home cook List</h1>
      <div className="search-container">
        <div className="input-fields">
          <input
            type="text"
            placeholder="Search By Name"
            {...register("name")}
            onChange={(e) => {
              const value = e.target.value;
              const formatted = capitalizeWords(value);
              setValue("name", formatted);
            }}
          />

          <input
            type="text"
            placeholder="Search by Phone Number"
            {...register("mobileNumber")}
          />
          <select id="gender" {...register("gender")}>
            <option value="">Gender</option>
            {GENDER_OPTIONS.map((opt) => (
              <option value={opt.value} key={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
          <select id="status" {...register("status")}>
            <option value="">Status</option>
            {statusOptions.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
        </div>
        <div className="button-fields">
          <Button
            title="Search"
            width="16rem"
            fill="true"
            onclick={handleSubmit(search)}
          />
          <Button
            title="Reset"
            width="16rem"
            fill="true"
            backgroundcolor="var(--reset-button)"
            onclick={reset}
          />
        </div>
      </div>
      <div className="data-table">
        <table>
          <thead>
            <tr>
              {columns.map((column: any, index: number) => {
                return (
                  <th className={column.class} key={index}>
                    {column.name}
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody>
            {data?.length > 0 ? (
              data?.map((chef, index) => (
                <tr key={index}>
                  <td>
                    <div
                      style={{
                        display: "flex",
                        gap: "1rem",
                        alignItems: "center",
                        fontSize: "14px",
                      }}
                    >
                      <img
                        src={
                          chef?.image
                            ? chef?.image
                            : PlaceholderImage
                        }
                        alt="img"
                        height={40}
                        width={40}
                        style={{ borderRadius: "50%" }}
                      />{" "}
                      <TruncatedTd> {chef.name}</TruncatedTd>
                    </div>
                  </td>
                  <td>{chef?.email}</td>
                  <td>({chef?.countryCode})-{chef?.mobileNumber}</td>
                  <td className="th">{chef?.gender}</td>
                  <TruncatedTd className="th">
                    {chef?.address}
                  </TruncatedTd>
                  <td>
                    <label className="toggle-button">
                      <input
                        type="checkbox"
                        checked={chef.status}
                        onChange={() => toggleUserStatus(chef.id, chef.status)}
                      />
                      <span className="slider round"></span>
                    </label>
                  </td>

                  <td className="actions th">
                    <div
                      className="view-container"
                      onClick={() => handleViewPage(chef?.id, chef)}
                    >
                      <img src={view} alt="img" />
                    </div>
                    {/* <img src={deleteIcon} alt='img' onClick={handleDelete}/> */}
                  </td>
                </tr>
              ))
            ) : (
              <NoDataFound isShow={!isLoading} />
            )}
          </tbody>
        </table>
      </div>
      <Fragment>
        <Pagination
          totalRecords={homeCookPaginationState?.total}
          perPage={limit}
          handleFetchNextRecords={fetchNextRecords}
        />
      </Fragment>
    </Container>
  );
};

export default HomeChef;
